import { lazy, Suspense } from 'react';
import { GuestGuard } from 'src/auth-guard/guest-guard';
import { SplashScreen } from 'src/components/loading-screen';
import { HOMEPAGE_TITLE } from 'src/constants/common';
import AuthClassicLayout from 'src/layouts/auth/classic';

// ----------------------------------------------------------------------

// JWT
const LoginPage = lazy(() => import('src/pages/auth/login/login-page'));

// ----------------------------------------------------------------------

// const authJwt = {
//   path: 'jwt',
//   element: (
//     <GuestGuard>
//       <Suspense fallback={<SplashScreen />}>
//         <Outlet />
//       </Suspense>
//     </GuestGuard>
//   ),
//   children: [
//     {
//       path: 'login',
//       element: (
//         <AuthClassicLayout title="디어먼데이 관리자 홈페이지">
//           <JwtLoginPage />
//         </AuthClassicLayout>
//       )
//     }
//   ]
// };

export const logoutRequiredRoutes = [
  {
    path: '/auth',
    children: [
      {
        path: 'login',
        element: (
          <GuestGuard>
            <Suspense fallback={<SplashScreen />}>
              <AuthClassicLayout title={HOMEPAGE_TITLE}>
                <LoginPage />
              </AuthClassicLayout>{' '}
            </Suspense>
          </GuestGuard>
        )
      }
    ]
  }
];
